export DocumentIcon from '@material-ui/icons/Description'
export DocumentList from './List'
export DocumentCreate from './Create'
export DocumentEdit from './Edit'
export DocumentQueries from './queries'
